/**
 * Share Class for implementing social sharing on Facebook, Twitter, LinkedIn, Pinterest, Whatsapp and email.
 *
 * When implementing this share module also:
	- use Yoast plugin, enable open graph en check settings,
	- use the template-part part-share.php.
 */

const share = {};

/**
 * Function to determine position of the opened share options
 *
 * Based on the fold and the top position of the share button, this function will determine if the share options should open above or below the share button.
 */
function setOpenPosition(el) {

	let openPos = 'top';

	// if is below fold then 'bottom':
	let fold = window.innerHeight / 2;
	let sharePos = el.getBoundingClientRect().top;

	if (fold > sharePos) {
		openPos = 'bottom';
	}

	el.classList.remove(`open-at-bottom`);
	el.classList.remove(`open-at-top`);
	el.classList.add(`open-at-${openPos}`);

}


/**
 * Function to initialize socials media.
 *
 * When clicking on the option Facebook, Twitter, LinkedIn or Pinterest, it will open a window, and close the share options.
 * When clicking on a link it wil close the share options.
 *
 * @listens share-item--facebook~event:eventClick
 * @listens share-item--twitter~event:eventClick
 * @listens share-item--linkedin~event:eventClick
 * @listens share-item--pinterest~event:eventClick
 * @listens event:eventClick
 *
 */
function initSocialShares(el, options) {

	// Facebook:
	el.querySelector('.share-item--facebook').addEventListener('click', function () {
		let loc = this.dataset.target;
		window.open(
			'https://www.facebook.com/sharer/sharer.php?u=' + loc,
			'facebook-share-dialog',
			'width=626,height=436');
		closeShare(el, options);
		return false;
	});
	// Twitter:
	el.querySelector('.share-item--twitter').addEventListener('click', function () {
		let loc = encodeURIComponent(this.dataset.target);
		let title = escape(this.dataset.title);
		window.open(
			'https://twitter.com/share?url=' + loc + '&text=' + title,
			'twitterwindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 225) + ', left=' + $(window).width() / 2,
			'twitter-share-dialog',
			'width=626,height=436');
		closeShare(el, options);
		return false;
	});

	// LinkedIn:
	el.querySelector('.share-item--linkedin').addEventListener('click', function () {
		var loc = encodeURIComponent(this.dataset.target);
		window.open(
			'https://www.linkedin.com/shareArticle?mini=true&url=' + loc,
			'linkedin-share-dialog',
			'width=650,height=450');
		closeShare(el, options);
		return false;
	});

	// Pinterest:
	// el.querySelector('.share-item--pinterest').addEventListener('click', function () {
	// 	var loc = encodeURIComponent(this.dataset.target);
	// 	var title = escape(this.dataset.title);
	// 	var img = escape(this.dataset.image);
	// 	window.open(
	// 		'https://www.pinterest.com/pin/create/button/?url=' + loc +
	// 		'&media=' + img +
	// 		'&description=' + title,
	// 		'pinterest-share-dialog',
	// 		'width=650,height=450');
	// 	closeShare(el, options);
	// 	return false;
	// });

	// Whatsapp & email:
	el.querySelector('.share-item > a').addEventListener('click', function (e) {
		closeShare(el, options);
	});
}

/**
 * Function to close share options
 */
function closeShare(el, options) {

	el.classList.remove('is-active');

}

/**
 * Function to open share options
 */
function openShare(el, options) {

	// Check if there is a other share button allready open
	const elAllreadyOpen = document.querySelector('.js-share.is-active');
	if (elAllreadyOpen) {
		elAllreadyOpen.querySelector('button').click();
	}

	setOpenPosition(el);
	setTimeout(() => {
		el.classList.add('is-active');
	}, 10);

}

/**
 * Function that fires when initializing share in index.js.
 *
 * For each share module set the variables, init the social share options and add event listener 'click'.
 */
share.init = function () {

	document.querySelectorAll('.js-share').forEach(function (node) {

		const el = node,
			btn = node.querySelector('.js-open-share'),
			options = node.querySelector('.js-share-options');

		// Init socials:
		initSocialShares(el, options);

		// Click event handler:
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			if (el.classList.contains('is-active')) {
				closeShare(el, options);
			} else {
				openShare(el, options);
			}
		});

	});

	// Close share if click outside button
	document.addEventListener('click', function (e) {

		document.querySelectorAll('.js-share.is-active').forEach(function (node) {
			const el = node,
				options = node.querySelector('.js-share-options');
			closeShare(el, options);
		});

	});

};

export { share };
